import { request } from '@/api/request';

const $axios = request()
export const subscribe = (params: any): Promise<any> => {
    // return $axios.post('/mainGate/savePartner', { ...params, loading: true })
    return $axios.post('/mainGate/savePartner', { ...params })
}